import { classNames } from '../../utils';
import { getLetter } from '../../lib/LessonPart';

const _ = require('lodash');


function QuizItemBlock({ number, item, answer, onChangeAnswer, isWrong, isCorrect }) {
  const handleChange = (event) => {
    onChangeAnswer(item.id, parseInt(event.target.value));
  };

  const handleChangeMulti = (event) => {
    answer = answer || [];
    const var_id = parseInt(event.target.value);
    answer = _.remove(answer, n => n.toString() !== var_id.toString());
    if (event.target.checked) answer.push(var_id);
    onChangeAnswer(item.id, answer);
  };

  const handleChangeText = (event) => {
    answer = answer || new Array(parseInt(event.target.dataset.total));
    answer[event.target.dataset.number] = event.target.value;
    onChangeAnswer(item.id, answer);
  };

  const handleChangeTable = (event) => {
    answer = answer || new Array(parseInt(event.target.dataset.total));
    answer[event.target.dataset.number] = event.target.value;
    onChangeAnswer(item.id, answer);
  };

  const itemClass = classNames({
    'quiz-item': true,
    'quiz-item--wrong': isWrong,
    'quiz-item--correct': isCorrect,
  });

  const header = (
    <div className="quiz-item__header">
      <span className="quiz-item__number">{number}</span>
      <p className="quiz-item__question" dangerouslySetInnerHTML={{ __html: item.question }} />
    </div>
  );

  if (item.question_type === "SIMPLE") {
    return (
      <div className={itemClass}>
        {header}
        <div className="quiz-options">
          {item.question_data["choices"].map((choice, j) => (
            <label key={"quiz-item-choice" + j} className={classNames({ 'quiz-option': true, 'quiz-option--selected': answer === j })}>
              <input type="radio" name={`quiz-${item.id}`} value={j} checked={answer === j} onChange={handleChange} />
              <span className="quiz-option__letter">{getLetter(j)}</span>
              <span className="quiz-option__text">{choice}</span>
            </label>
          ))}
        </div>
      </div>
    );
  }

  if (item.question_type === "MULTI_SIMPLE") {
    return (
      <div className={itemClass}>
        {header}
        <div className="quiz-options">
          {item.question_data["choices"].map((choice, j) => {
            const checked = _.indexOf(answer, j) >= 0;
            return (
              <label key={"quiz-item-choice" + j} className={classNames({ 'quiz-option': true, 'quiz-option--selected': checked })}>
                <input type="checkbox" value={j} checked={checked} onChange={handleChangeMulti} />
                <span className="quiz-option__letter">{getLetter(j)}</span>
                <span className="quiz-option__text">{choice}</span>
              </label>
            );
          })}
        </div>
      </div>
    );
  }

  if (item.question_type === "TEXT") {
    let parts = item.question_data["text"].split(/(\[place\])/gi);
    let total_number = 0;
    for (let j = 0; j < parts.length; j++) {
      if (parts[j].toLowerCase() === "[place]") total_number++;
    }
    let current = 0;
    parts = parts.map((part, i) => {
      if (part.toLowerCase() === "[place]") {
        const idx = current++;
        return (
          <input
            key={idx}
            className="quiz-text-input"
            type="text"
            data-number={idx}
            data-total={total_number}
            onChange={handleChangeText}
            value={_.get(answer, [idx], "")}
          />
        );
      }
      return part;
    });

    return (
      <div className={itemClass}>
        {header}
        <div className="quiz-text-body">{parts}</div>
      </div>
    );
  }

  if (item.question_type === "TABLE") {
    return (
      <div className={itemClass}>
        {header}
        <div className="quiz-table-wrapper">
          <table className="quiz-table">
            <thead>
              <tr>
                <th></th>
                {[...Array(item.question_data["cols"])].map((__, i) => (
                  <th key={i}>{getLetter(i)}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...Array(item.question_data["rows"])].map((__, j) => (
                <tr key={j}>
                  <td className="quiz-table__row-label">{j + 1}</td>
                  {[...Array(item.question_data["cols"])].map((__, i) => (
                    <td key={i} className="quiz-table__cell">
                      <input
                        type="radio"
                        className="quiz-table__radio"
                        checked={_.get(answer, j, "").toString() === i.toString()}
                        onChange={handleChangeTable}
                        data-number={j}
                        data-total={item.question_data["rows"]}
                        value={i}
                        name={`quiz-table-${item.id}-row${j}`}
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default QuizItemBlock;
